import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

import { ref } from 'vue';
import { getRecruitApplyList } from '@/request';
import { getVexTableProps, dateFormat } from '@/config';
export default {
  name: 'RecruitApplyList',

  setup(__props) {
    const form = ref({
      noticeTitle: '',
      linkPhone: '',
      time: []
    });
    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        field: 'noticeTitle',
        title: '公告标题',
        minWidth: '180px',
        showOverflow: true
      }, {
        field: 'linkMan',
        title: '姓名',
        width: '100px'
      }, {
        field: 'gender',
        title: '性别',
        width: '80px'
      }, {
        field: 'linkPhone',
        title: '手机号',
        width: '130px'
      }, {
        field: 'regionNames',
        title: '报名区域',
        minWidth: '180px',
        showOverflow: true
      }, {
        field: 'loginName',
        title: '登录账号',
        width: '130px',
        showOverflow: true
      }, {
        field: 'applyTime',
        title: '报名时间',
        width: '170px'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            var _form$value$time, _form$value$time2;

            getRecruitApplyList({
              page: page.currentPage,
              pageSize: page.pageSize,
              noticeTitle: form.value.noticeTitle,
              linkPhone: form.value.linkPhone,
              startTime: ((_form$value$time = form.value.time) === null || _form$value$time === void 0 ? void 0 : _form$value$time[0]) || '',
              endTime: ((_form$value$time2 = form.value.time) === null || _form$value$time2 === void 0 ? void 0 : _form$value$time2[1]) || ''
            }).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.list
              });
            });
          })
        }
      }
    });

    function reset() {
      form.value = {
        noticeTitle: '',
        linkPhone: '',
        time: []
      };
      table.value.commitProxy('reload');
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, null, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "公告标题"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.noticeTitle,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.noticeTitle = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "手机号"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.linkPhone,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.linkPhone = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "报名时间"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.time,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.time = $event),
                type: "daterange",
                "range-separator": "至",
                "start-placeholder": "开始",
                "end-placeholder": "结束",
                "value-format": _unref(dateFormat),
                "unlink-panels": ""
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[3] || (_cache[3] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), null, 16)]);
    };
  }

};